import * as React from "react";

const InventoryIcon = (props) => (
  <svg
    width={props?.width ?? 24}
    height={props?.height ?? 24}
    stroke="none"
    fill={props?.fill ?? "#000000"}
    viewBox="0 0 32 32"
    id="icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="2"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier" stroke={props?.stroke ?? "none"} fill="none">
      <defs></defs>
      <rect x="19" y="24" width="4" height="4"></rect>
      <rect x="26" y="24" width="4" height="4"></rect>
      <rect x="19" y="17" width="4" height="4"></rect>
      <rect x="26" y="17" width="4" height="4"></rect>
      <path d="M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z" fill={props?.fill ?? "#000000"}></path>
      
    </g>
  </svg>
);

export default InventoryIcon;
